export default {
    startPage: {
        title: 'Vue 学习'
    },
    menu: {
        Documents: '스포츠 기록',
        Setting: '시스템 설정',
        Applications: "테스트 시스템",
        Report: "분석 보고서",
        AthleteDocuments: "운동선수",
        SportProject: "스포츠 종목",
        Options: "기본 설정",
        Permission: "권한 관리",
        StandardData: "표준값 관리",
        MuscleStrengthStandard: '휴대용 근력 참조값',
        UserManagement: "인원 관리",
        Subject: "운동선수 상세 정보",
        Record: "개인 기록",
        Result: "테스트 결과",
        Actions: "동작 데이터",
        SportsPerformanceStandardData: '스포츠 기능 수행 시스템',
        MuscleStrengthStandardData: '휴대용 근력 테스트 시스템',
    },
    userMenu: {
        confirmExit: '로그아웃',
        confirmMsg: '로그아웃 하시겠습니까?',
        DarkMode: '다크 모드',
        Modify: '자료 수정',
        Account: '계정',
        UserName: '사용자 이름',
    },
    options: {
        Title: '선호 설정',
        Language: '언어',
        ModifyNotice: '수정 성공',
        ModifyNotice2: '수정 실패',
        SystemSettings: '기본 설정',
        AccountSetting: '계정 설정',
        Account: '계정',
        OrganizationInfo: '조직 정보',
        CompanyName: '회사 이름:',
        CompanyCode: '회사 코드:',
        CustomLogo: '사용자 정의 로고',
        Name: '이름',
        Preview: '미리 보기',
        UploadPictures: '클릭하여 이미지 업로드',
        Notice1: '이미지 최적 크기는 높이 48px, 너비 200px 이내, 1Mb 미만, png 또는 jpg 형식',
        ModifyPassword: '비밀번호 재설정/수정',
        confirmExit: '로그아웃',
        ModifyName: '이름 수정',
        notice2: '이름 수정 성공',
        notice3: '이름을 입력해 주세요',
        Lable: {
            Multilingual: '다국어',
            Logo: '사용자 정의 로고',
        }
    },
    login: {
        Label: {
            UserName: '계정',
            Password: '비밀번호',
            Login: '로그인',
            Reset: '재설정',
            Title: '로그인 해주세요',
            Title2: '등록',
            Forget: '비밀번호를 잊으셨나요?',
            Remember: '비밀번호 저장',
            Register: '등록하기>>',
            ToLogin: '이미 계정이 있으신가요? 로그인하기>>',
            Captche: '인증 코드 받기',
            Retry: '다시 받기',
            Agree: '《사용자 계약》에 동의합니다',
            UserNamePlaceholde: '사용자 이름을 입력해 주세요',
            PasswordPlaceholde: '비밀번호를 입력해 주세요',
            CompanyCodePlaceholder: '회사 코드',
            MailBoxPlaceHolder: '이메일을 입력해 주세요',
            CaptchaPlaceholder: '이메일 인증 코드',
        },
        Message: {
            PasswordLength: '비밀번호는 8~16자 사이여야 합니다',
            CaptchaSuccess: '인증 코드 발송 성공',
            Agree: '《사용자 계약》을 읽고 체크해 주세요',
            AccountEmpty: '이메일을 정확히 입력해 주세요',
            Registered: '등록 성공',
            loginFaild: "로그인 실패",
            Captcha: '인증 코드 길이가 부족합니다',
            CaptchaLenthL: '인증 코드를 완전히 입력해 주세요',
            CompanyCodeLength: '정확한 회사 코드를 입력해 주세요',
        }
    },
    forget: {
        Label: {
            Title: '비밀번호 찾기',
            GoToLogin: '로그인하기>>',
            Captche: '인증 코드 받기',
            Reset: '비밀번호 재설정',
            Retry: '다시 받기',
            Contact: '이 페이지에서 해결되지 않으면 고객 서비스에 문의하세요',
            AccountPlaceholder: '로그인 이메일을 입력해 주세요',
            CaptchaPlaceholder: '이메일 인증 코드',
            PasswordPlaceholder: '새 비밀번호',
            ModifyPassword: '비밀번호 수정',
        },
        Message: {
            CaptchaSuccess: '인증 코드 발송 성공',
            ResetSuccess: '비밀번호 재설정 성공',
            AccountEmpty: '이메일을 정확히 입력해 주세요',
        }
    },
    global: {
        HomePage: '메인 페이지',
        Loading: '로딩 중',
        CopySuccess: '복사 성공',
        CopyFailed: '복사 실패',
        Refresh: '새로 고침',
        Add: '추가',
        Create: '생성',
        Modify: '수정',
        Confirm: '확인',
        Cancel: '취소',
        Save: '저장',
        View: "보기",
        Edit: "편집",
        Delete: "삭제",
        Finish: "완료",
        LastWeek: "최근 일주일",
        LastMonth: "최근 한 달",
        Last3Month: "최근 세 달",
        StartDate: "시작 날짜",
        EndDate: "종료 날짜",
        TestProject: "테스트 프로젝트",
        SportProject: "스포츠 프로젝트",
        None: "제한 없음",
        Gender: "성별",
        RequestFailed: '요청 실패!',
        ResponseFailed: '응답 실패!',
        LoadSuccess: '다운로드 성공',
        LoadFailed: '다운로드 실패',
        EditRelation: '운동 관계 편집',
        EditSubject: '운동선수 정보 편집',
        EditProject: '스포츠 프로젝트 편집',
        Import: '가져오기',
        Export: '내보내기',
        NoneData: '데이터 없음',
        NoneRank: '순위 없음',
        SaveSuccess: "저장 성공",
        Checked: '선택됨',
        Close: '닫기',
    },
    Permission: {
        Label: {
            Title: "권한 관리",
            Enable: "활성화",
            Description: '설명',
            ExpireDate: '만료일',
            CreateGroup: "그룹 생성",
            GroupRole: "역할 유형",
            GroupName: "역할 이름",
            SelectRoleType: "역할 유형 선택",
        },
        Message: {
            GetGroupsFailed: "그룹 가져오기 실패",
            GetApplicationListFailed: '애플리케이션 목록 가져오기 실패',
            ChangeUnsaved: "저장되지 않은 변경 사항이 있습니다. 나가시겠습니까?",
            ComfirmToDelete: "이 그룹을 삭제하시겠습니까?",
            DeleteSuccess: '삭제 성공',
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: '개인 기록 보기',
            InvationInfo: '사용자 등록 초대',
            DeleteInvation: '초대 삭제',
            ViewHistoryRecords: '기록 내역 보기',
            ViewDetailRecords: '기록 상세 보기',
            TestDetialExport: '기록 상세 내보내기',
            ViewActionDetail: '동작 상세 보기',
            ActionDataExport: '동작 데이터 내보내기',
        },
        HomePage: '메인 페이지',
        Reinvite: '재초대',
        SportDocuments: '스포츠 기록',
        RegisterSubject: {
            Title: '자료 보완 초대',
            Save: '자료 제출',
            From: '에서',
            Invitation: '초대',
            PlaseEnter: '입력해 주세요',
        },
        Athletes: {
            TotalCount: '현재 총',
            TotalProjects: '개 프로젝트',
            DeleteNotice: '정보 작성 초대 상태인 운동선수를 삭제하시겠습니까?',
            ProjectNameSearch: '스포츠 프로젝트 이름 검색 지원',
            selectDate: '날짜 선택',
            CreateTime: '생성 시간',
            ClickShow: '클릭하여 펼치기',
            ClickPutaway: '클릭하여 접기',
            FormarErrorNotice: '(참고: 소수점 이하 한 자리까지만 유효)',
            EmailNoticeLogin: '이메일(로그인에 사용 가능)',
            LoginEmail: '로그인에 사용 가능',
            Athletes: '운동선수',
            MultipleSelection: '다중 선택',
            true: '다중 선택',
            false: '완료',
            AddDocuments: '기록 추가',
            TestSystem: '테스트 시스템 단일 선택',
            Nodata: '데이터 없음',
            SportFunction: '스포츠 기능 수행 테스트 시스템',
            DigitalRunway: '디지털 런웨이 데이터 수집 분석 소프트웨어',
            MuscleStrength: '근력 테스트 시스템',
            GolfTechnique: '골프 기술 진단',
            Screening: '필터링',
            GenderLimit: '성별 제한 없음',
            SystemLimit: '시스템 제한 없음',
            TestProject: '테스트 프로젝트',
            Photo: '사진',
            NextPage: '다음 페이지',
            PreviousPage: '이전 페이지',
            Age: '나이',
            View: '보기',
            EditingData: '자료 편집',
            HistoricalRecord: '기록 내역',
            SkipPages: '페이지 건너뛰기',
            AddTestProject: '+ 테스트 프로젝트에 추가',
            AssociationSportProject: '+ 스포츠 프로젝트 연결',
            DeldeteDocument: '기록 삭제',
            Complete: '완료',
            SearchNotice: '이름 검색 지원',
            CreateSubject: '기록 추가',
            ModifySubject: '기록 수정',
            AddRelationSuccessNotice: '연결 추가 성공',
            AddRelationFailNotice: '연결 추가 실패',
            AddRelationNotice: '연결할 프로젝트를 선택해 주세요',
            BaseInfo: '기본 정보',
            InviteUsersRegister: '사용자 등록 초대',
            Save: '저장',
            Total: '총',
            Projects: '개 프로젝트 전체',
            Picture: '사진',
            PhotoLimitNotice: '1M 이내 사진만 허용',
            PhotoLimitNotice2: '1M 이내 사진을 업로드해 주세요',
            Name: '이름',
            EnterNotice: '운동선수 이름을 입력해 주세요',
            Gneder: '성별',
            Birthday: '생일',
            Height: '키',
            Weight: '몸무게',
            EnterWeightNotice: '운동선수 몸무게를 입력해 주세요',
            EnterHeightNotice: '운동선수 키를 입력해 주세요',
            PhoneNumber: '전화번호',
            EnterPhoneNumberNotice: '전화번호를 입력해 주세요',
            RequiredNotice: '비워둘 수 없습니다',
            PhoneNumberNotice: '올바른 번호 형식을 입력해 주세요',
            Email: '이메일',
            EnterEmailNotice: '이메일을 입력해 주세요',
            EmailNotice: '올바른 이메일 형식을 입력해 주세요',
            PictureFileNotice: '올바른 이미지 파일을 선택해 주세요',
            PictureSizeNotice: '이미지는 1M 미만으로 선택해 주세요',
            Manage: '관리',
            Add: '+ 추가',
            Years: '세',
            FormarError: '데이터 형식이 올바르지 않습니다',
            ViewDocument: '기록 보기',
            AddToProject: '프로젝트에 추가',
            Record: '기록',
            LoadAll: '모든 자료를 로드했습니다',
            Reset: '재설정',
            Invationing: '초대 내역',
            BatchExportIndicator: '일괄 내보내기 지표',
            BatchExportRawData:'원본 데이터 일괄 내보내기',
            Link: {
                Invitation: '사용자 등록 초대',
                FileName: '기록 이름',
                LoginEmail: '가입 이메일',
                InvitationLink: '초대 링크',
                SendInvitation: '초대 발송',
                CopyLink: '링크 복사',
                LinkNotice: '사용자가 자료를 제출해야 기록 생성이 완료됩니다',
                InvitationOther: '다른 사용자 초대',
                Notice: '복사 성공',
                Notice2: '복사 실패',
                Notice3: '초대 발송 성공',
                Notice4: '초대 발송 실패',
                InvationNotice: '운동선수 이름을 입력하고 링크를 생성하면 초대 링크가 입력된 이메일로 직접 발송됩니다',
                Notice5: '운동선수 이름을 입력해 주세요',
            },
            Details: {
                RelationToProject: '프로젝트에 추가',
                ModifySocument: '자료 수정',
                RelationRecord: '관련 기록',
                None: '없음',
                SwingSide: '타자',
                PowerLeg: '주동력 다리',
                LeftHand: '왼손',
                RightHand: '오른손',
                LeftLeg: '왼다리',
                RightLeg: '오른다리',
                Left: '왼쪽',
                Right: '오른쪽',
                LeftRight: '좌우',
                ShoeSize: '신발 사이즈',
                Statistics: '데이터 통계',
                ClickNotice: '동작이나 숫자를 클릭하여 상세 내용을 확인하세요',
                Unit: {
                    SwingSide: '손',
                    PowerLeg: '다리',
                    ShoeSize: '사이즈',
                }
            },
            TestRecord: {
                TestRecord: '테스트 기록',
                StartDate: '시작 날짜',
                EndDate: '종료 날짜',
                SelectNotice: '먼저 테스트 시스템을 선택해 주세요',
                Time: '시간',
                None: '없음',
                DataLength: '개 기록',
            },
            Result: {
                Application8: {
                    'Swing': '팔 흔들기',
                    'Akimbo': '허리에 손을 얹기',
                    'Other': '기타',
                    'Bilateral': '양측',
                    'Left': '좌측',
                    'Right': '우측',
                    'MidThighPull': '대퇴부 중앙 하드풀',
                    '1_4Squat': '1/4 스쿼트',
                    'CalfRaise': '발뒤꿈치 들기',
                    'Customization': '사용자 정의',
                    'ITest': 'I 테스트',
                    'YTest': 'Y 테스트',
                    'TTest': 'T 테스트',
                    'FreeMode': '자유 모드',
                    'TimekeepingMode': '타이머 모드',
                    'UpperLimbs': '상지',
                    'LowerLimbs': '하지',
                    '力': '힘',
                    '时间': '시간',
                    '速度/加速度': '속도/가속도',
                    '功率': '출력',
                    '位移': '변위',
                    '其他': '기타',
                    '冲量': '충격량',
                    '频率': '주파수',
                    'Remark': '비고',
                    '': '',
                    'ImportantLeftRightRatio': '중점 좌우 분량',
                    'OtherLeftRightRatio': '기타 좌우 분량 비교',
                    'ArmWeight': '팔 무게'
                },
                SendNotice: '보낼 내용을 선택해 주세요',
                SendSuccessfully: '발송 성공',
                EmailContent: '이메일 내용',
                SendEmail: '이메일 발송',
                ReceivingEmail: '수신 이메일',
                COPPosition: 'COP',
                ModelSetting: '모듈 설정',
                ModelType: '테스트 모듈',
                L_Fz_COP: 'L-COP 연결선',
                R_Fz_COP: 'R-COP 연결선',
                Fz_COP: '합력-COP 연결선',
                Left: '왼쪽',
                Right: '오른쪽',
                Fz: '합력',
                COP: 'COP 뷰',
                AllFz: '합력-Fz',
                Legend: '범례',
                Asi: '비대칭 지수',
                LeftRightRatio: '좌-우 비율',
                HistoryMax: '기록 최고',
                Now: '현재',
                MainIndicators: '주요 지표',
                OtherIndicators: '기타 지표',
                ExtendedIndicators: '확장 지표',
                SingleView: '단일 지표',
                NumberOfTimes: '횟수',
                NoData: '데이터 없음',
                GoBack: '돌아가기',
                RawData: "원시 기록 다운로드",
                Export: '지표 내보내기',
                Weight: '테스트 체중',
                Duration: '테스트 기간',
                GolfClubs: '골프 클럽 사용',
                Spacing: '스탠스 간격',
                LeftAngle: '좌측 각도',
                RightAngle: '우측 각도',
                LeftLeg: '왼다리',
                RightLeg: '오른다리',
                ResultantForce: '합력',
                Limbs: '몸통',
                Side: '부위',
                Actions: '동작',
                Pose: '자세',
                Order: '순서',
                Joint: '관절',
                KneePosition: '무릎 위치',
                Times_L: '왼발 횟수',
                Times_R: '오른발 횟수',
                0: '기본값',
                1: '좌측',
                2: '우측',
                3: '왼쪽 먼저 오른쪽 나중',
                4: '오른쪽 먼저 왼쪽 나중',
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: 'T회',
                ExportReport: '보고서 내보내기',
                Repetitions: '반복 횟수',
                ContainsPersonalRecords: "개인 기록 포함",
                MuscleStrengthAvgIndicator: {
                    最大峰值力: '최대 피크 힘값',
                    平均峰值力: '평균 피크 힘값',
                    到达峰值时间: '피크 도달 시간',
                    峰值发力率: '피크 발력률',
                    峰值力: '피크 힘값',
                },
                '左侧最大范围': '좌측 최대 범위',
                '左侧最大范围时间': '좌측 최대 범위 시간',
                '右侧最大范围': '우측 최대 범위',
                '右侧最大范围时间': '우측 최대 범위 시간',
                '左侧平均范围': '좌측 평균 범위',
                '最大范围BSA': '최대 범위 BSA',
                '右侧平均范围': '우측 평균 범위',
                '最大范围': '최대 범위',
                '平均范围': '평균 범위',
                '最大范围时间': '최대 범위 시간',
                Times: '회',
                NumberOfTests: '테스트 횟수',
                LeftSide: '좌측',
                RightSide: '우측',
                数值: "수치",
                ReferenceValue: '참조값',
                Internal: '내회전',
                External: '외회전',
                Adduction: '내전',
                Abduction: '외전',
                Varus: '내반슬',
                Valgus: '외반슬',
                MaximumForceRatio: '최대 힘값 비율',
                AvgForce: '평균 피크 힘값',
                MaxForce: '최대 피크 힘값',
                MaxImpulse: '최대 충격량',
                AvgImpulse: '평균 충격량',
                AvgForce_Baseline: '평균 피크 힘값(기준값)',
                MaxForce_Baseline: '최대 피크 힘값(기준값)',
                MaxImpulse_Baseline: '최대 충격량(기준값)',
                AvgImpulse_Baseline: '평균 충격량(기준값)',
            },
            Action: {
                Action: '동작 데이터',
                TrendChart: '추세 차트',
                IndexNotice: '보려는 지표를 선택해 주세요',
                RelationRecord: '관련 기록',
                Delete: '삭제',
                Export: '선택한 기록 내보내기',
                None: '없음',
                ExportData: '원시 데이터 내보내기',
                ExportData1: '데이터 내보내기',
                EcportIndex: '지표 내보내기',
                ExportReport: '보고서 내보내기',
                C3DReport: 'C3D 내보내기',
                ViewRecord: '기록 보기',
                Index: '지표',
                Report: '보고서',
                Data: '원시 데이터',
                Total: '총',
                Datas: '개 데이터',
                Max: '최대값',
                Min: '최소값',
                Notice: '먼저 기록을 선택해 주세요',
                NoIndex: '지표 없음',
            },
            SingleCreate: '수동 추가',
            DownloadTemplate: '가져오기 템플릿 다운로드',
            SubjectImportTemplate: "피험자 임포트 템플릿",
            ImportFromTemplate: '템플릿 일괄 가져오기',
            Template: '운동선수 일괄 가져오기 템플릿',
            Upload: "가져오기",
            ImportSuccess: '가져오기 성공',
            ImportFailed: '가져오기 실패',
            Items: '항목',
        },
        SportProjects: {
            SportProjects: '스포츠 프로젝트',
            AddSportProjectNotice: '스포츠 프로젝트는 운동선수 구분용으로만 사용됩니다',
            ProjectName: '프로젝트 이름',
            AddProject: '프로젝트 추가',
            RelatedCount: '관련 인원',
            Operate: '작업',
            RelatedAthletes: '관련 운동선수',
            AddSportProject: '스포츠 프로젝트 추가',
            notice1: '최소 하나를 선택해 주세요',
            SelectApplications: '응용 시스템',
            ProNameNotice: '스포츠 프로젝트 이름을 입력해 주세요',
            addSuccessNotice: '스포츠 프로젝트 추가 성공',
            addFaildNotice: '스포츠 프로젝트 추가 실패',
            deleteSuccessNotice: '스포츠 프로젝트 삭제 성공',
            deleteFaildNotice: '스포츠 프로젝트 삭제 실패',
            updateSuccessNotice: '스포츠 프로젝트 수정 성공',
            updateFaildNotice: '스포츠 프로젝트 수정 실패',
            CreateSportProject: '스포츠 프로젝트 생성',
            EmptyNotice: '프로젝트 이름을 입력해 주세요',
            People: '명',
            Name: '이름',
            Gender: '성별',
            Birthday: '생일',
            ModifyName: '수정',
            ModifySportProject: '스포츠 프로젝트 수정',
            modifySuccessNotice: '프로젝트 이름 수정 성공',
            modifyFaildNotice: '프로젝트 이름은 중복될 수 없습니다',
            AddSport: '운동선수 관리',
            Athletes: '운동선수',
            QueryError: '조회 실패',
            Added: '이미 추가됨',
            SaveFailNotice: '저장 실패',
            SaveSuccessNotice: '저장 성공',
            NotSaved: '내용이 저장되지 않았습니다. 나가시겠습니까?',
            DeleteNotice: '이 스포츠 프로젝트를 삭제하시겠습니까?',
            Notice: '알림',
            DeleteProjcctNotice: '스포츠 프로젝트 삭제',
        }
    },
    Application: {
        Name: {
            1: '근력 테스트 시스템',
            5: '골프 기술 진단 시스템',
            6: "햄스트링 테스트 시스템",
            7: '다기능 힘 측정 프레임',
            8: '스포츠 기능 수행 테스트 시스템',
            9: '관절 가동 범위',
        },
        Label: {
            Detail: "상세 보기",
            SubjectCount: '운동선수',
            RecordCount: '테스트 기록',
            ProjectCount: '테스트 프로젝트',
            RankList: "순위 표시",
            More: "더 보기>",
            TrendCharts: "테스트 추세",
            Indicators: "지표 표시",
            ExportIndicators: "지표 내보내기",
            TrainingPlan: '훈련 계획',
            MostRecentRecord: '최근 기록',
            AllRecords: '모든 기록',
        },
        Options: {
            LastDays: "최근 %d일"
        },
        Columns: {
            CreateTime: "생성 시간"
        },
    },
    Report: {
        Label: {
            MinAvgMax: '최소/최대',
            ReportChart: '데이터 보고서 차트',
            Query: '필터링',
            Export: '내보내기',
            IndicatorOptions: '지표 필터링',
            SubjectOptions: '운동선수 선택',
            MaxValue: '최대값',
            MinValue: '최소값',
            InsertChart: '차트 추가',
            ModifyChart: '차트 수정',
            true: '최대값',
            false: '최소값',
            指标: '지표',
            值: '값',
            单位: '단위'
        },
        Message: {
            IndicatorsEmpty: "지표를 선택해 주세요",
            SubjectEmpty: "운동선수를 선택해 주세요",
        },
        Indicators: {
            峰值: '피크값',
            峰值时间: '피크 시간',
            最大发力率: '최대 발력률',
            最大峰值力: '최대 피크 힘값',
            平均峰值力: '평균 피크 힘값',
            到达峰值时间: '피크 도달 시간',
            峰值发力率: '피크 발력률',

            左脚平均峰值力: '왼발 평균 피크 힘값',
            右脚平均峰值力: '오른발 평균 피크 힘값',
            左脚最大力值: '왼발 최대 힘값',
            右脚最大力值: '오른발 최대 힘값',
            左脚重复次数: '왼발 반복 횟수',
            右脚重复次数: '오른발 반복 횟수',
            左重复次数: '왼쪽 반복 횟수',
            右重复次数: '오른쪽 반복 횟수',
            内收左重复次数: '내전 왼쪽 반복 횟수',
            内收右重复次数: '내전 오른쪽 반복 횟수',
            外展左重复次数: '외전 왼쪽 반복 횟수',
            外展右重复次数: '외전 오른쪽 반복 횟수',
            内旋左重复次数: '내회전 왼쪽 반복 횟수',
            内旋右重复次数: '내회전 오른쪽 반복 횟수',
            外旋左重复次数: '외회전 왼쪽 반복 횟수',
            外旋右重复次数: '외회전 오른쪽 반복 횟수',
            内翻左重复次数: '내반슬 왼쪽 반복 횟수',
            内翻右重复次数: '내반슬 오른쪽 반복 횟수',
            外翻左重复次数: '외반슬 왼쪽 반복 횟수',
            外翻右重复次数: '외반슬 오른쪽 반복 횟수',
            左最大力值: '왼쪽 최대 힘값',
            右最大力值: '오른쪽 최대 힘값',
            内收左最大力值: '내전 왼쪽 최대 힘값',
            内收右最大力值: '내전 오른쪽 최대 힘값',
            外展左最大力值: '외전 왼쪽 최대 힘값',
            外展右最大力值: '외전 오른쪽 최대 힘값',
            内旋左最大力值: '내회전 왼쪽 최대 힘값',
            内旋右最大力值: '내회전 오른쪽 최대 힘값',
            外旋左最大力值: '외회전 왼쪽 최대 힘값',
            外旋右最大力值: '외회전 오른쪽 최대 힘값',
            内翻左最大力值: '내반슬 왼쪽 최대 힘값',
            内翻右最大力值: '내반슬 오른쪽 최대 힘값',
            外翻左最大力值: '외반슬 왼쪽 최대 힘값',
            外翻右最大力值: '외반슬 오른쪽 최대 힘값',
            左脚扭矩: '왼발 토크',
            右脚扭矩: '오른발 토크',
            左脚峰值力最大值: '왼발 피크 힘값 최대값',
            右脚峰值力最大值: '오른발 피크 힘값 최대값',
            峰值力最大值BSA: '피크 힘값 최대값 BSA',
            左脚峰值力平均值: '왼발 피크 힘값 평균값',
            右脚峰值力平均值: '오른발 피크 힘값 평균값',
            峰值力平均值BSA: '피크 힘값 평균값 BSA',
            左脚冲量平均值: '왼발 충격량 평균값',
            右脚冲量平均值: '오른발 충격량 평균값',
            冲量平均值BSA: '충격량 평균값 BSA',
            左脚冲量最大值: '왼발 충격량 최대값',
            右脚冲量最大值: '오른발 충격량 최대값',
            冲量最大值BSA: '충격량 최대값 BSA',


            'Absolute': '절대값',
            'Relative': '상대값',
            'LeftComponent': '좌측',
            'RightComponent': '우측',
            '缓冲最小力值': '최소 언웨이팅 힘',
            '制动最大力值': '최대제동력',
            '蹬伸最大力值': '최대추진력',
            '落地最大力值': '최대 착지 힘',
            '离心制动阶段发力率': '제동 국면 힘 발현 속도(RFD)',
            '制动最大力值发力率': '추진 국면 힘 발현 속도(RFD)',
            '蹬伸平均功率': '평균 추진 파워',
            '蹬伸峰值功率': '최대 추진 파워',
            '离心制动阶段冲量': '제동 임펄스',
            '向心阶段净冲量': '구심성 임펄스',
            '下蹲时间': '신장성 지속 시간',
            '制动时间': '제동 시간',
            '蹬伸时间': '추진 시간',
            '蹬伸与制动时间比': '추진/제동 시간 비율',
            '峰值功率发生时刻': '최대 파워 도달 시간',
            '触地时间': '이륙까지 시간',
            '腾空时间': '체공 시간',
            '落地稳定时间': '안정화 시간',
            '下蹲平均速度': '평균 신장성 속도',
            '离心阶段峰值速度': '최대 신장성 속도',
            '向心阶段最大速度': '최대 구심성 속도',
            '峰值功率发生时速度': '최대 파워 시 속도',
            '起跳速度': '이륙 속도',
            '腾空高度Hv': '점프 높이(v)',
            '腾空高度': '점프 높이',
            '腾空高度Ht': '점프 높이(t)',
            '腾空高度HFt': '점프 높이(ft)',
            '下蹲深度': '하강 깊이',
            '反应力量指数RSI': 'RSI',
            '反应力量指数RSImod': '수정 RSI',
            '动态力量指数DSI': 'DSI',
            '左侧动态力量指数DSI': 'DSI(좌측)',
            '右侧动态力量指数DSI': 'DSI(우측)',
            '离心利用率EUR': 'EUR',
            '预拉伸增强百分比PSAP': 'PSAP',
            '弹性指数ESI': 'ESI',
            '落地表现指数': '착지 퍼포먼스 지수',
            '最大蹬伸力发力率': '최대 힘 발현 속도(RFD)',
            '跌落峰值力': '최대 제동력',
            '左侧跌落峰值力': '최대 제동력(좌측)',
            '右侧跌落峰值力': '최대 제동력(우측)',
            '蹬伸峰值力': '최대 추진력',
            '跌落峰值力加载率': '제동 국면 힘 발현 속도(RFD)',
            '左侧跌落峰值力加载率': '제동 국면 힘 발현 속도(좌측)',
            '右侧跌落峰值力加载率': '제동 국면 힘 발현 속도(우측)',
            '蹬伸峰值力发力率': '추진 국면 힘 발현 속도(RFD)',
            '离心阶段冲量': '신장성 임펄스',
            '跌落峰值力到达时间': '최대 제동력 도달 시간',
            '左侧跌落峰值力到达时间': '최대 제동력 도달 시간(좌측)',
            '右侧跌落峰值力到达时间': '최대 제동력 도달 시간(우측)',
            '蹬伸峰值加速度': '최대 추진 가속도',
            '绝对最大力值': '최대 힘',
            '单位体重最大力值': '상대 최대 힘',
            '左侧最大力值': '최대 힘(좌측)',
            '右侧最大力值': '최대 힘(우측)',
            '50ms发力率': 'RFD(50ms)',
            '100ms发力率': 'RFD(100ms)',
            '150ms发力率': 'RFD(150ms)',
            '200ms发力率': 'RFD(200ms)',
            '250ms发力率': 'RFD(250ms)',
            '300ms发力率': 'RFD(300ms)',
            '50ms冲量': '임펄스(50ms)',
            '100ms冲量': '임펄스(100ms)',
            '150ms冲量': '임펄스(150ms)',
            '200ms冲量': '임펄스(200ms)',
            '250ms冲量': '임펄스(250ms)',
            '300ms冲量': '임펄스(300ms)',
            '到达最大力值时间': '최대 힘 도달 시간',
            '左侧到达最大力值时间': '최대 힘 도달 시간(좌측)',
            '右侧到达最大力值时间': '최대 힘 도달 시간(우측)',
            '平均缓冲最大力值': '평균 최대 제동력',
            '平均蹬伸最大力值': '평균 추진 시간',
            '平均缓冲最大力值加载率': '평균 제동 RFD',
            '平均缓冲时间': '평균 제동 시간',
            '平均蹬伸时间': '평균 추진 시간',
            '平均触地时间': '평균 이륙 시간',
            '平均腾空时间': '평균 체공 시간',
            '平均起跳速度': '평균 이륙 속도',
            '平均腾空高度': '평균 점프 높이',
            '平均蹬伸功率': '평균 추진 파워',
            '平均蹬伸峰值功率': '평균 최대 추진 파워',
            '平均下蹲速度': '평균 신장성 속도',
            '平均下蹲深度': '평균 하강 깊이',
            '缓冲最大力值': '최대 제동력',
            '缓冲最大力值加载率': '제동 RFD',
            '蹬伸功率': '추진 파워',
            '缓冲时间': '제동 시간',
            '下蹲速度': '신장성 속도',
            '蹲起时间': '스쿼트 시간',
            '下蹲和蹬伸时间比': '신장/추진 시간 비율',
            '平均击打峰值力': '평균 태핑 최대 힘',
            '平均击打时间': '평균 접지 시간',
            '平均撤离时间': '평균 체공 시간',
            '频率': '주파수',
            '初段平均频率': '평균 주파수(초기 구간)',
            '中段平均频率': '평균 주파수(중기 구간)',
            '末段平均频率': '평균 주파수(말기 구간)',
            '最小自由频率': '최소 주파수',
            '最大自由频率': '최대 주파수',
            '总计次数': '반복 횟수',
            '耐力指数': '지구력 지수',
            '疲劳指数': '피로 지수',
            '落地峰值力': '최대 착지 힘',
            '左侧落地峰值力': '최대 착지 힘(좌측)',
            '右侧落地峰值力': '최대 착지 힘(우측)',
            '落地峰值力加载率': '착지 RFD',
            '左侧落地峰值力加载率': '착지 RFD(좌측)',
            '右侧落地峰值力加载率': '착지 RFD(우측)',
            '落地峰值力到达时间': '최대 착지 힘 도달 시간',
            '左侧落地峰值力到达时间': '최대 착지 힘 도달 시간(좌측)',
            '右侧落地峰值力到达时间': '최대 착지 힘 도달 시간(우측)',
            '落地到恢复稳定时间': '안정화 시간',
            '触地时间差': '접지 시간 차이',
            '左右摇晃速度': 'CoP 속도(좌우)',
            '前后摇晃速度': 'CoP 속도(전후)',
            '总体摇晃速度': 'CoP 속도',
            '左右晃动幅度': 'CoP 이동 범위(좌우)',
            '前后晃动幅度': 'CoP 이동 범위(전후)',
            '左右摇晃幅度': 'CoP 이동 범위(좌우)',
            '前后摇晃幅度': 'CoP 이동 범위(전후)',
            '落地顺序': '착지 순서',
            '左右平均摇晃速度': 'CoP 속도(좌우)',
            '前后平均摇晃速度': 'CoP 속도(전후)',
            '总体平均摇晃速度': '평균 CoP 속도',
            '左右摇晃轨迹长度': 'CoP 이동 거리(좌우)',
            '前后摇晃轨迹长度': 'CoP 이동 거리(전후)',
            '总体摇晃轨迹长度': '총 CoP 이동 거리',
            '左右摇晃最大幅度': 'CoP 이동 범위(좌우)',
            '前后摇晃最大幅度': 'CoP 이동 범위(전후)',
            '轨迹包络面积': 'CoP 흔들림 면적',
            '最大净力值': '최대 힘',
            '最大力值': '최대 힘',
            '最小力值': '최소 힘',
            '平均力': '평균 힘',
            '冲量': '임펄스',
            '上箱高度Ht': '목표 높이',
            '平均反应力量指数RSI': '평균 RSI',
            '缓冲最小力值分量': '최소 언웨이팅 힘 - 좌측/우측',
            '制动最大力值分量': '최대제동력 - 좌측/우측',
            '蹬伸最大力值分量': '최대추진력 - 좌측/우측',
            '落地最大力值分量': '최대 착지 힘 - 좌측/우측',
            '离心制动阶段发力率分量': '제동 국면 힘 발현 속도(RFD) - 좌측/우측',
            '制动最大力值发力率分量': '추진 국면 힘 발현 속도(RFD) - 좌측/우측',
            '蹬伸平均功率分量': '평균 추진 파워 - 좌측/우측',
            '蹬伸峰值功率分量': '최대 추진 파워 - 좌측/우측',
            '离心制动阶段冲量分量': '제동 임펄스 - 좌측/우측',
            '向心阶段净冲量分量': '구심성 임펄스 - 좌측/우측',
            '最大蹬伸力发力率分量': '최대 힘 발현 속도(RFD) - 좌측/우측',
            '跌落峰值力分量': '최대 제동력 - 좌측/우측',
            '蹬伸峰值力分量': '최대 추진력 - 좌측/우측',
            '跌落峰值力加载率分量': '제동 국면 힘 발현 속도(RFD) - 좌측/우측',
            '蹬伸峰值力发力率分量': '추진 국면 힘 발현 속도(RFD) - 좌측/우측',
            '离心阶段冲量分量': '신장성 임펄스 - 좌측/우측',
            '绝对最大力值分量': '최대 힘 - 좌측/우측',
            '单位体重最大力值分量': '상대 최대 힘 - 좌측/우측',
            '50ms发力率分量': 'RFD(50ms) - 좌측/우측',
            '100ms发力率分量': 'RFD(100ms) - 좌측/우측',
            '150ms发力率分量': 'RFD(150ms) - 좌측/우측',
            '200ms发力率分量': 'RFD(200ms) - 좌측/우측',
            '250ms发力率分量': 'RFD(250ms) - 좌측/우측',
            '300ms发力率分量': 'RFD(300ms) - 좌측/우측',
            '50ms冲量分量': '임펄스(50ms) - 좌측/우측',
            '100ms冲量分量': '임펄스(100ms) - 좌측/우측',
            '150ms冲量分量': '임펄스(150ms) - 좌측/우측',
            '200ms冲量分量': '임펄스(200ms) - 좌측/우측',
            '250ms冲量分量': '임펄스(250ms) - 좌측/우측',
            '300ms冲量分量': '임펄스(300ms) - 좌측/우측',
            '平均缓冲最大力值分量': '평균 최대 제동력 - 좌측/우측',
            '平均蹬伸最大力值分量': '평균 추진 시간 - 좌측/우측',
            '平均缓冲最大力值加载率分量': '평균 제동 RFD - 좌측/우측',
            '平均蹬伸功率分量': '평균 추진 파워 - 좌측/우측',
            '平均蹬伸峰值功率分量': '평균 최대 추진 파워 - 좌측/우측',
            '缓冲最大力值分量': '최대 제동력 - 좌측/우측',
            '平均击打峰值力分量': '평균 태핑 최대 힘 - 좌측/우측',
            '平均击打时间分量': '평균 접지 시간 - 좌측/우측',
            '平均撤离时间分量': '평균 체공 시간 - 좌측/우측',
            '落地峰值力分量': '최대 착지 힘 - 좌측/우측',
            '落地峰值力加载率分量': '착지 RFD - 좌측/우측',
            '最大力值分量': '최대 힘 - 좌측/우측',
            '最小力值分量': '최소 힘 - 좌측/우측',
            '平均力分量': '평균 힘 - 좌측/우측',
            '冲量分量': '임펄스 - 좌측/우측',
            '动态反弹指数DRI': '동적 반발 지수 （DRI）',
            '平均反应力量指数RSImod': '평균 수정 RSI',
            '': ''
        }
    },
    UserManagement: {
        Label: {
            Member: "멤버",
            Disabled: "비활성화된 사용자",
            SelectRole: "역할 선택",
            SelectGroup: "권한 그룹 선택",
            FilterByAccountName: "계정 또는 사용자 이름으로 검색",
            BatchOperate: "일괄 처리",
            CreateAccount: "새 사용자 추가",
            Enanble: "사용자 복원",
            Disable: "사용자 비활성화",
            Delete: "영구 삭제",
            Permission: "권한",
            Information: "정보 수정",
            Role: "역할",
            PermissionGroup: "권한 그룹",
            DefaultGroup: "기본 그룹",
            Account: "계정",
            Password: "비밀번호",
            Name: "이름",
            ModifyPermission: "사용자 권한 수정",
            ModifyAccountInfo: "사용자 정보 수정",
            Prev: "이전 페이지",
            Next: "다음 페이지",
            CreateConfirm: "사용자 생성",
        },
        Columns: {
            AvatarAccount: "头像/账号",
            UserName: "姓名",
            CreateTime: "创建时间",
            RolePermission: "角色/权限",
            Operate: "操作",
        },
        Message: {
            LengthNotice: '8~16자리 입력해 주세요',
            AccountFillNotice: '비밀번호는 이메일 형식이어야 합니다',
            ConfirmDisable: "해당 사용자를 비활성화하시겠습니까?",
            ConfirmEnable: "해당 사용자를 복원하시겠습니까?",
            ConfirmDelete: "해당 사용자를 영구 삭제하시겠습니까?",
            ConfirmPermissionModify: "해당 사용자 권한을 수정하시겠습니까?",
            ConfirmModifyAccountInfo: "수정 내용을 저장하시겠습니까?",
            PermissionModifySuccess: "권한 수정 성공",
            PWNotice: '비밀번호를 비워둘 수 없습니다',
            NameNotice: '이름을 비워둘 수 없습니다',
        }
    },
    Role: {
        0: "운동선수",
        1: "코치",
        63: "관리자",
        127: "운영 인력",
        255: "슈퍼 관리자",
        Subject: "운동선수",
        Coach: "코치",
        Admin: "관리자",
        OM: "운영 인력",
    },
    Gender: {
        0: "남",
        1: "여",
        2: '기타'
    },
    ActionModel: {
        RecordCount: '기록 수',
        ProjectCount: '프로젝트 수',
        Nordic: '노르딕 스타일',
        Razor: '레이저 스타일',
        IsometricContraction_0: '0° 등장 수축',
        IsometricContraction_30: '30° 등장 수축',
        IsometricContraction_60: '60° 등장 수축',
        Irons: "아이언",
        Woods: "우드",
        Wedges: "웨지",
        Hybrids: "하이브리드",
        Putter: "퍼터",
        Iron1: "1번 아이언",
        Iron2: "2번 아이언",
        Iron3: "3번 아이언",
        Iron4: "4번 아이언",
        Iron5: "5번 아이언",
        Iron6: "6번 아이언",
        Iron7: "7번 아이언",
        Iron8: "8번 아이언",
        Iron9: "9번 아이언",
        Iron10: "10번 아이언",
        Driver: "드라이버",
        Wood3: "3번 우드",
        Wood5: "5번 우드",
        Wood7: "7번 우드",
        Wood9: "9번 우드",
        Pitch: "피치",
        Wedge48: "48° 웨지",
        Wedge50: "50° 웨지",
        Wedge52: "52° 웨지",
        Wedge54: "54° 웨지",
        Wedge56: "56° 웨지",
        Wedge58: "58° 웨지",
        Wedge60: "60° 웨지",
        Wedge62: "62° 웨지",
        Hybrid1: "1번 하이브리드",
        Hybrid2: "2번 하이브리드",
        Hybrid3: "3번 하이브리드",
        Hybrid4: "4번 하이브리드",
        Hybrid5: "5번 하이브리드",
        Hybrid6: "6번 하이브리드",
        Hybrid7: "7번 하이브리드",
        '1': '목',
        '2': '앞으로 구부리기',
        '3': '뒤로 젖히기',
        '4': '왼쪽으로 구부리기',
        '5': '오른쪽으로 구부리기',
        '6': '앉은 자세',
        '7': '앉은 자세',
        '8': '앉은 자세',
        '9': '앉은 자세',
        '10': '어깨',
        '11': '좌측',
        '12': '우측',
        '13': '내회전',
        '14': '외회전',
        '15': '내전',
        '16': '외전',
        '17': '전방 굴곡',
        '18': '후방 신전',
        '19': 'ISO I 테스트',
        '20': 'ISO Y 테스트',
        '21': 'ISO T 테스트',
        '22': '앉은 자세-90° 팔꿈치 굴곡',
        '23': '앉은 자세-90° 팔꿈치 굴곡 90° 어깨 외전',
        '24': '서 있는 자세-팔꿈치 90°',
        '25': '서 있는 자세-90° 팔꿈치 굴곡 90° 어깨 외전 90° 어깨 외회전',
        '26': '누운 자세-90° 팔꿈치 굴곡 90° 어깨 외전',
        '27': '누운 자세-90° 팔꿈치 굴곡',
        '28': '엎드린 자세',
        '29': '앉은 자세-90° 팔꿈치 굴곡',
        '30': '앉은 자세 90° 팔꿈치 굴곡 90° 어깨 외전',
        '31': '서 있는 자세-90° 팔꿈치 굴곡',
        '32': '서 있는 자세-90° 팔꿈치 굴곡-90° 어깨 외전',
        '33': '누운 자세-90° 팔꿈치 굴곡-90° 어깨 외전',
        '34': '누운 자세-90° 팔꿈치 굴곡',
        '35': '엎드린 자세',
        '36': '앉은 자세',
        '37': '서 있는 자세',
        '38': '앉은 자세',
        '39': '서 있는 자세',
        '40': '옆으로 누운 자세',
        '41': '앉은 자세-90° 어깨 외전',
        '42': '서 있는 자세',
        '43': '서 있는 자세-90° 팔꿈치 굴곡',
        '44': '앉은 자세',
        '45': '서 있는 자세',
        '46': '앉은 자세-90° 어깨 굴곡',
        '47': '서 있는 자세-90° 어깨 굴곡',
        '48': '누운 자세',
        '49': '누운 자세',
        '50': '엎드린 자세',
        '51': '누운 자세',
        '52': '엎드린 자세',
        '53': '누운 자세',
        '54': '엎드린 자세',
        '55': '몸통',
        '56': '앞으로 구부리기',
        '57': '왼쪽으로 구부리기',
        '58': '오른쪽으로 구부리기',
        '59': '앉은 자세',
        '60': '앉은 자세',
        '61': '앉은 자세',
        '62': '엉덩이',
        '63': '좌측',
        '64': '우측',
        '65': '전방 굴곡',
        '66': '후방 신전',
        '67': '내회전',
        '68': '외회전',
        '69': '내전',
        '70': '외전',
        '71': '서 있는 자세',
        '72': '엎드린 자세',
        '73': '엎드린 자세-90° 무릎 굴곡',
        '74': '반 엎드린 자세',
        '75': '서 있는 자세',
        '76': '누운 자세',
        '77': '앉은 자세',
        '78': '앉은 자세',
        '79': '누운 자세',
        '80': '엎드린 자세',
        '81': '앉은 자세',
        '82': '누운 자세',
        '83': '엎드린 자세',
        '84': '누운 자세',
        '85': '누운 자세-45° 무릎 굴곡',
        '86': '누운 자세-팔꿈치 90°',
        '87': '누운 자세',
        '88': '누운 자세-45° 무릎 굴곡',
        '89': '누운 자세-팔꿈치 90°',
        '90': '옆으로 누운 자세',
        '91': '팔꿈치',
        '92': '좌측',
        '93': '우측',
        '94': '전방 굴곡',
        '95': '후방 신전',
        '96': '앉은 자세-90° 팔꿈치 굴곡-손목 관절 중립위',
        '97': '앉은 자세-90° 팔꿈치 굴곡-손목 관절 전회전',
        '98': '앉은 자세-90° 팔꿈치 굴곡-손목 관절 후회전',
        '99': '앉은 자세-90° 팔꿈치 굴곡 90° 어깨 외전-손목 관절 중립위',
        '100': '앉은 자세-90° 팔꿈치 굴곡 90° 어깨 외전-손목 관절 전회전',
        '101': '서 있는 자세-90° 팔꿈치 굴곡-손목 관절 중립위',
        '102': '앉은 자세-90° 팔꿈치 굴곡',
        '103': '손목',
        '104': '좌측',
        '105': '우측',
        '106': '후회전',
        '107': '전회전',
        '108': '전방 굴곡',
        '109': '후방 신전',
        '110': '척측 편전',
        '111': '요측 편전',
        '112': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '113': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '114': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '115': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '116': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '117': '90° 팔꿈치 굴곡-손목 관절 전회전',
        '118': '90° 팔꿈치 굴곡-손목 관절 후회전',
        '119': '90° 팔꿈치 굴곡-손목 관절 중립위',
        '120': '90° 팔꿈치 굴곡-손목 관절 전회전',
        '121': '90° 팔꿈치 굴곡-손목 관절 후회전',
        '122': '손',
        '123': '좌측',
        '124': '우측',
        '125': '그립력',
        '126': '앉은 자세-90° 팔꿈치 굴곡-손목 관절 중립위',
        '127': '앉은 자세-손목 관절 중립위',
        '128': '앉은 자세-90° 어깨 굴곡-손목 관절 중립위',
        '129': '무릎',
        '130': '좌측',
        '131': '우측',
        '132': '굴곡',
        '133': '신전',
        '134': '앉은 자세',
        '135': '엎드린 자세',
        '136': '누운 자세',
        '137': '앉은 자세-90° 무릎 굴곡',
        '138': '엎드린 자세-90° 무릎 굴곡',
        '139': '누운 자세',
        '140': '발목',
        '141': '좌측',
        '142': '우측',
        '143': '내반',
        '144': '외반',
        '145': '배굴',
        '146': '발바닥 굴곡',
        '147': '다리 펴고 앉은 자세',
        '148': '다리 펴고 앉은 자세',
        '149': '다리 펴고 앉은 자세',
        '150': '다리 펴고 앉은 자세',
        '151': '발',
        '152': '좌측',
        '153': '우측',
        '154': '발가락 굴곡',
        '155': '발가락 신전',
        '156': '앉은 자세',
        '157': '다리 펴고 앉은 자세-발바닥 굴곡',
        '158': '다리 펴고 앉은 자세-발바닥 중립',
        '159': '앉은 자세',
        '160': '다리 펴고 앉은 자세-발바닥 중립',
        '161': '다리 펴고 앉은 자세-발바닥 굴곡',
        '162': '서 있는 자세',
        '163': '누운 자세',
        '164': '서 있는 자세',
        '165': '누운 자세',
        '166': '서 있는 자세',
        '167': '누운 자세',
        '168': '서 있는 자세',
        '169': '누운 자세',
        '170': '옆으로 누운 자세',
        '171': '옆으로 누운 자세',
        '172': '견갑골 상승',
        '173': '견갑골 전방 신전',
        '174': '견갑골 후방 수축',
        '175': '앉은 자세',
        '176': '앉은 자세',
        '177': '앉은 자세',
        '178': '앉은 자세-90° 팔꿈치 굴곡',
        '179': '서 있는 자세-90° 팔꿈치 굴곡',
        '180': '누운 자세-90° 팔꿈치 굴곡',
        '181': '앉은 자세-90° 팔꿈치 굴곡',
        '182': '서 있는 자세-90° 팔꿈치 굴곡',
        '183': '엎드린 자세',
        '184': '앉은 자세-90° 어깨 외전',
        '185': '앉은 자세-90° 어깨 외전-90° 팔꿈치 굴곡',
        '186': '앉은 자세-90° 팔꿈치 굴곡',
        '187': '앉은 자세-90° 어깨 외전-90° 팔꿈치 굴곡',
        '188': '서 있는 자세-90° 팔꿈치 굴곡',
        '189': '옆으로 누운 자세-90° 팔꿈치 굴곡',
        '190': '앉은 자세-90° 팔꿈치 굴곡 90° 어깨 외전 90° 어깨 외회전',
        '191': '앉은 자세-90° 팔꿈치 굴곡 90° 어깨 외전 90° 어깨 외회전',
        '192': '옆으로 누운 자세-90° 팔꿈치 굴곡',
        '193': '서 있는 자세-90° 팔꿈치 굴곡-손목 관절 전회전',
        '194': '서 있는 자세-90° 팔꿈치 굴곡-손목 관절 후회전',
        '195': '서 있는 자세-90° 팔꿈치 굴곡',
        '197': '기타',
        '198': '서 있는 자세-90° 무릎 굴곡',
        '199': '앉은 자세-45° 무릎 굴곡',
        '200': '반 누운 자세',
        '201': '엎드린 자세-45° 무릎 굴곡',
        '205': '대퇴부 중앙 하드풀',
        '206': '서 있는 자세',
        '207': '90° 팔꿈치 굴곡-손목 관절 후회전',
        '208': '90° 팔꿈치 굴곡-손목 관절 전회전',
        'Hip_Joint': '고관절',
        'Buckling': '굴곡',
        'Stand_Straight': '서 있는 자세-다리 펴기',
        'Stand_Knees_Kick': '서 있는 자세-무릎 차기',
        'Stomach_Knees_30': '엎드린 자세-무릎 30° 굴곡',
        'Sit_Knees_90': '앉은 자세-무릎 90° 굴곡',
        'Back_Knees_90': '누운 자세-무릎 90° 굴곡',
        'Spread': '신전',
        'Stomach_Knees_Thigh': '엎드린 자세-무릎 90° 굴곡-대퇴부 후면',
        'Stand_Upright_Ankle': '서 있는 자세-다리 펴기-발목',
        'Adduction_Abduction': '내전/외전',
        'Back_Knees_120': '누운 자세-무릎 120° 굴곡',
        'Back_Knees_135': '누운 자세-무릎 135° 굴곡',
        'Stance_Ankles': '서 있는 자세-발목 부위',
        'Standing_Knees': '서 있는 자세-무릎 부위',
        'Back_Ankles': '누운 자세-발목 부위',
        'Back_Knees': '누운 자세-무릎 부위',
        'Internal_External': '내회전/외회전',
        'Stomach_Knees_90': '엎드린 자세-무릎 90° 굴곡',
        'Knee_Joint': '무릎 관절',
        'Stomach_Knees_45': '엎드린 자세-무릎 45° 굴곡',
        'Stand_Knees_90': '서 있는 자세-무릎 90° 굴곡',
        'Back_Knees_45': '누운 자세-무릎 45° 굴곡',
        'Sit_Knees_10': '앉은 자세-무릎 10° 굴곡',
        'Sit_Knees_45': '앉은 자세-무릎 45° 굴곡',
        'Back_Knees_10': '누운 자세-무릎 10° 굴곡',
        'Ankle_Joint': '발목 관절',
        'Dorsiflexion': '배굴',
        'Sitting_Position': '앉은 자세',
        'Varus_Valgus': '내반/외반',
        'Back_StraightLegs': '누운 자세-다리 펴기',
        'Toe_Flexion': '발가락 굴곡',
        'Lie_Supine': '누운 자세',
        'Shoulder_Joint': '어깨 관절',
        'Stomach_Straight': '엎드린 자세-팔 펴기',
        'Abduction': '외전',
        'Side_Straight': '옆으로 누운 자세-팔 펴기',
        'Adduction': '내전',
        'Shoulder_Elbow': '누운 자세-어깨 외전 90° 팔꿈치 굴곡 90°',
        'Elbow_Neutral': '누운 자세-중립위 팔꿈치 굴곡 90°',
        'Articulatio_Cubiti': '팔꿈치 관절',
        'Sit_Elbows_90': '앉은 자세-팔꿈치 굴곡 90°',
        'Neck': '목',
        'Default_Position': '기본 자세',
        'Lateral_Flexion': '측면 굴곡',
        'Other': '기타',
        'Upper_Push': '상지 밀기',
        Default: '기본',
        Left: '좌',
        Right: '우',
        Left_To_Right: '먼저 좌측 후 우측',
        Right_To_Left: '먼저 우측 후 좌측',
        simultaneously: '좌우 동시',
        Null: '없음',
        'CMJ': '스쿼트 점프',
        'SJ': '쪼그려 앉아',
        'DropJump': '낙하 점프',
        'MVC': '최대 자발 수축',
        'RepetitiveHopping': '연속 직립 점프',
        'RepetitiveCMJ': '연속 스쿼트 점프',
        'Squat': '스쿼트',
        'Stamping': '상하 운동 빈도 및 지구력 테스트',
        'Landing': '착지 테스트',
        'Balance': '균형 테스트',
        'AthleticShoulder': '어깨 관절 테스트',
        'Free': '자유 테스트',
        'DJ': '점프 딥',
        'Inside': '내측',
        'Outside': '외측',
        '踝关节': '발목 관절',
        '肘关节': '팔꿈치 관절',
        '髋关节': '고관절',
        '颈部': '목',
        '肩关节': '어깨 관절',
        '躯干': '몸통',
        '膝关节': '무릎 관절',
        '腕关节': '손목 관절',
        '腕关节尺偏': '손목 관절 척측 편전',
        '髋关节外旋': '고관절 외회전',
        '髋关节内收': '고관절 내전',
        '髋关节外展': '고관절 외전',
        '颈部屈曲': '목 굴곡',
        '颈部伸展': '목 신전',
        '颈部侧屈': '목 측면 굴곡',
        '颈部旋转': '목 회전',
        '肩关节内旋': '어깨 관절 내회전',
        '肩关节外旋': '어깨 관절 외회전',
        '肩关节屈曲': '어깨 관절 굴곡',
        '踝内翻': '발목 내반',
        '踝外翻': '발목 외반',
        '足背屈': '발바닥 배굴',
        '足跖屈': '발바닥 굴곡',
        '肘伸展': '팔꿈치 신전',
        '肘屈曲': '팔꿈치 굴곡',
        '髋关节伸展': '고관절 신전',
        '髋关节屈曲': '고관절 굴곡',
        '髋关节内旋': '고관절 내회전',
        '肩关节外展': '어깨 관절 외전',
        '躯干伸展': '몸통 신전',
        '躯干侧屈': '몸통 측면 굴곡',
        '膝关节屈曲': '무릎 관절 굴곡',
        '膝关节伸展': '무릎 관절 신전',
        '腕关节桡偏': '손목 관절 요측 편전',
        '肩关节水平内收': '어깨 관절 수평 내전',
        '肩关节水平外展': '어깨 관절 수평 외전',
        '肩关节伸展': '어깨 관절 신전',
        '躯干屈曲': '몸통 굴곡',
        '躯干旋转': '몸통 회전',
        '腕关节旋前': '손목 관절 전회전',
        '肩关节内收': '어깨 관절 내전',
        '腕关节旋后': '손목 관절 후회전',
        '腕关节屈曲': '손목 관절 굴곡',
        '腕关节伸展': '손목 관절 신전',
        '仰卧位': '누운 자세',
        '仰卧位（直腿）': '누운 자세（다리 펴기）',
        '仰卧位（肘屈曲 90°）': '누운 자세（팔꿈치 굴곡 90°）',
        '仰卧位（肩外展 90° - 肘屈曲 90°）': '누운 자세（어깨 외전 90°-팔꿈치 굴곡 90°）',
        '侧卧位': '옆으로 누운 자세',
        '俯卧位': '엎드린 자세',
        '俯卧位（肩外展 90° - 肘屈曲 90°）': '엎드린 자세（어깨 외전 90°-팔꿈치 굴곡 90°）',
        '半跪姿': '반 무릎 꿇은 자세',
        '坐位': '앉은 자세',
        '坐位（肘屈曲 90°）': '앉은 자세（팔꿈치 굴곡 90°）',
        '坐位（肩外展 90° - 肘屈曲 90°）': '앉은 자세（어깨 외전 90°-팔꿈치 굴곡 90°）',
        '站立位': '서 있는 자세',
        '站立位（肘屈曲 90°）': '서 있는 자세（팔꿈치 굴곡 90°）',
        '站立位（肩外展 90° - 肘屈曲 90°）': '서 있는 자세（어깨 외전 90°-팔꿈치 굴곡 90°）',
        '肘屈曲90°': '팔꿈치 굴곡 90°',
        '长坐位（无跖屈）': '긴 앉은 자세（발바닥 굴곡 없음）',
        '长坐位（跖屈）': '긴 앉은 자세（발바닥 굴곡）',
        '动作模块': '액션 모듈',
        Wrist: '손목',
        Flexion: '굴곡',
        Extension: '신전',
        Supination: '회외',
        Pronation: '회내',
        Ulnar_Deviation: '척측 편위',
        Radial_Deviation: '요측 편위',
        Wrist_Neutral: '팔꿈치 90° - 손목 중립위치',
        Wrist_Supination: '팔꿈치 90° - 손목 회외',
        Wrist_Pronation: '팔꿈치 90° - 손목 회내'
    },
    StandardData: {
        Title: "표준값 관리(휴대용 근력)",
        Assembly: "동작 조합",
        Limbs: '몸통',
        Actions: '동작',
        Pose: '자세',
        Gender: '성별',
        Age: '나이',
        PeakForce: '피크 힘값 N/kg',
        Modify: '표준값 설정',
        FileBrowsing: '파일 탐색',
        FileRequired: '가져올 파일을 선택하세요',
        DropFileHere: '파일을 여기로 드래그하세요',
        clickToUpload: '클릭하여 업로드',
        SportTitle: "표준값 관리(운동 기능 수행)",
        Mean: '평균값',
        Outstanding: '우수값',
        '青少年': '청소년',
        '18~30': '18~30',
        '31~45': '31~45',
        '46~60': '46~60',
        'AgeGroup': '연령대',
        ModifySuccess: '수정 성공',
        ErrorRaw: '오류 행',
        ErrorInfo: '오류 정보',
        ErrorCount: '오류 수',
        Sure: '확인',
        ErrorStatistics: '오류 통계',
        EmptyId: 'ID를 입력해야 합니다',
        IdParseError: 'ID가 유효하지 않습니다',
        EmptyValue: '표준값을 입력해야 합니다',
        InvalidId: 'ID가 유효하지 않습니다',
        ValueParseError: '표준값이 유효하지 않습니다',
    },
    Project: {
        Public: '공개',
        Private: '비공개',
        Title: '테스트 항목',
        FilterName: '프로젝트 이름 검색',
        FilterSubject: '피험자 이름 검색',
        Columns: {
            CreateTime: '생성 시간',
            ProjectName: '프로젝트 명',
            CreatorName: '생성자 이름',
            Operate: '작업',
            Name: '이름',
            Gender: '성별',
            Age: '나이',
            SubjectName: '피험자 이름',
            Model: '테스트 동작',
        },
        RecordView: '기록',
        Batch: '일괄 처리',
        BatchDelete: '일괄 삭제',
        DeleteEmptyNotice: '삭제할 내용을 선택하세요',
        Finish: '완료',
        Create: '테스트 프로젝트 생성',
        View: '테스트 프로젝트',
        ProjectName: '프로젝트 명',
        Subjects: '피험자',
        AddSubject: '피험자 추가',
        PublicProject: '공개 프로젝트',
        PrivateProject: '비공개 프로젝트',
        ProjectType: '프로젝트 유형',
        CreateTime: '생성 시간',
        CreateProject: '프로젝트 생성',
        Save: '수정 사항 저장',
        ProjectSubjectList: '프로젝트 내 피험자 목록',
        NameFilter: '이름 검색',
        CreateSuccess: '생성 성공',
        ModifySuccess: '수정 성공',
        DeleteSuccess: '삭제 성공',
        DeleteFailed: '삭제 실패',
        NameTooLong: '이름이 너무 깁니다. 24자 이내로 입력해 주세요',
        RequireName: '프로젝트 이름을 입력해 주세요',
        SubjectManagerment: '피험자 관리',
        Added: '추가됨',
        DeleteConfirm: '프로젝트 삭제 시 관련 테스트 기록이 함께 삭제됩니다. 계속 진행하시겠습니까?',
        ConfirmToDeleteRow: '이 기록을 삭제하시겠습니까?',
        ConfromToDeleteSubjetc: '피험자 삭제 시 관련 테스트 기록이 함께 삭제됩니다. 계속 진행하시겠습니까?',
        DoNotAskAgain: '더 이상 알림하지 않음',
    },
    TrainingPlan: {
        Title: '훈련 계획',
        PlanType: '유형',
        Public: '공개',
        Private: '비공개',
        PlanName: '계획 명',
        Columns: {
            CreateTime: '생성 시간',
            PlanName: '계획 명',
            CreatorName: '생성자 이름',
            Operate: '작업',
            ActionCount: '동작 수량',
            Seq: '순번',
            Action: '동작',
            ActionTimes: '동작 반복 횟수',
            SubjectName: '피험자 이름',
            Completeness: '완료도',
            UsedTimes: '테스트 횟수',
            Model: '테스트 동작',
            Gender: '성별',
        },
        Skipped: '건너뛴',
        RecordView: '기록',
        Batch: '일괄 처리',
        BatchDelete: '일괄 삭제',
        Finish: '완료',
        Create: '훈련 계획 생성',
        Modify: '수정',
        Actions: '동작',
        Subjects: '피험자',
        Records: '테스트 기록',
        Statue: '완료 여부',
        Finished: '완료됨',
        Unfinish: '미완료',
        FilterName: '계획 명 검색',
        RequireName: '계획 명을 입력해 주세요',
        NameTooLong: '이름이 너무 깁니다. 50자 이내로 입력해 주세요',
        deleteRecord: '기록 삭제',
        DeleteConfirm: '작업 시 관련 테스트 기록이 함께 삭제됩니다. 계속 진행하시겠습니까?',
        AddAction: '동작 추가',
        TestActions: '테스트 동작',
        CreatePlan: '훈련 계획 생성',
        SavePlan: '테스트 계획 저장',
        Action: '동작',
        Times: '횟수',
        ActionAssembly: '동작 조합',
        RequireAssembly: '동작을 선택하세요',
        ConfirmDeleteAction: '이 동작을 삭제하시겠습니까?',
    },
    //运动表现标记线信息
    '动作开始': '동작 시작',
    '峰值': '피크값',
    '离地': '떨어짐',
    '落地': '착지',
    '开始': '시작',
    '制动': '제동',
    '最低点': '최저점',
    '落地峰值': '착지 피크값',
    '动作结束': '동작 종료',
    '跌落峰值': '낙하 피크값',
    '蹬伸峰值': '등척 피크값',
    '左侧最大力值': '좌측 최대 힘값',
    '右侧最大力值': '우측 최대 힘값',
    '50ms': '50ms',
    '100ms': '100ms',
    '150ms': '150ms',
    '200ms': '200ms',
    '250ms': '250ms',
    '300ms': '300ms',
    'TFmin': 'TFmin',
    'T1': 'T1',
    'TStart': 'TStart',
    'TEnd': 'TEnd',
    'PO': 'PO',
    '触地': '접지',
    '稳定': '안정',
    '最大垂直力值': '최대 수직 힘값',
    'A': 'A',
    'B': 'B',
    'C': 'C',
    'D': 'D',
    'E': 'E',
    '制动时刻': '제동 시점',
    '起跳时刻': '점프 시점',
    '蹬伸': '등척',
    '结束': '종료',
    //错误信息
    DefaultGroup: "기본 그룹",
    Empty_PhoneNumber: "휴대폰 번호를 입력해 주세요",
    Duplicate_PhoneNumber: "휴대폰 번호가 중복되어 다시 바인딩할 수 없습니다",
    Invalid_BOMType: "모듈 유형이 존재하지 않습니다!",
    InsertFailed_Assembly: "동작 추가에 실패했습니다!",
    Invalid_BOM: "모듈이 존재하지 않습니다!",
    InsertFailed_BOM: "모듈 추가에 실패했습니다!",
    UpdateFailed_BOM: "모듈 업데이트에 실패했습니다!",
    DeleteFailed_BOM: "모듈 삭제에 실패했습니다!",
    Invalid_Project: "프로젝트가 존재하지 않습니다!",
    Invalid_Subject: "피험자가 존재하지 않습니다!",
    Exsist_Account: "계정이 이미 존재합니다!",
    Invalid_Account: "계정이 존재하지 않습니다!",
    Incorrect_OldPassword: "이전 비밀번호가 올바르지 않습니다!",
    Invalid_Company: "해당 회사를 찾을 수 없습니다!",
    Invalid_CompanyID: "잘못된 회사 코드입니다!",
    Incorrect_ApplicationCode: "잘못된 앱 코드입니다!",
    Incorrect_AccountOrPassword: "사용자 이름 또는 비밀번호가 틀렸습니다!",
    Expired_Captcha: "인증 코드가 만료되었습니다!",
    Incorrect_Captcha: "인증 코드가 올바르지 않습니다!",
    Failed_SendCaptcha: "인증 코드 전송에 실패했습니다!",
    Invalid_Captcha: "잘못된 인증 코드입니다!",
    Empty_SubjectName: "피험자 이름을 입력해 주세요!",
    Repeat_SubjectName: "동명의 피험자가 이미 존재합니다!",
    Duplicate_Requests: "요청이 너무 잦습니다. 잠시 후 다시 시도해 주세요",
    UnknownError_Account: "현재 사용자가 존재하지 않습니다!",
    Locked_Company: "조직/회사가 잠겨 있습니다!",
    Expired_Authorization: "조직/회사 앱 인증이 만료되었습니다!",
    Invalid_Authorization: "조직/회사 앱 인증이 활성화되지 않았습니다!",
    Invalid_Parameter: "잘못된 매개변수입니다!",
    Invalid_License: "라이선스가 유효하지 않습니다!",
    Binded_License: "라이선스가 다른 기기에 이미 바인딩되었습니다!",
    Unbind_License: "라이선스가 아직 바인딩되지 않았습니다!",
    Expired_License: "라이선스가 만료되었습니다!",
    Failed_License: "라이선스 검증에 실패했습니다!",
    Empty_ApplictionCode: "애플리케이션 번호가 누락되었습니다!",
    Invalid_ApplictionCode: "애플리케이션 번호가 유효하지 않습니다!",
    Invalid_ApplictionEndPoint: "잘못된 시스템 노드입니다",
    Older_Version: "이전 버전 번호입니다",
    Empty_Version: "유효한 버전 번호가 없습니다",
    Duplicate_ApplicationCode: "중복된 시스템 식별 코드입니다",
    Invalid_Application: "잘못된 테스트 시스템입니다",
    Empty_Upgrade: "업데이트할 파일을 선택해 주세요",
    Invalid_Version: "잘못된 버전 번호입니다",
    Invalid_Record: "잘못된 기록입니다",
    NotFound_Record: "데이터 기록을 찾을 수 없습니다",
    Failed_ResetPassword: "비밀번호 재설정에 실패했습니다",
    Incomplete_Infomation: "입력 정보가 불완전합니다",
    Invalid_Binded: "잘못된 바인딩 기록입니다",
    ParallelLimit_License: "최대 바인딩 수를 초과했습니다",
    Exsist_PermissionGroup: "권한 그룹이 이미 존재합니다",
    Invalid_PermissionDenied: "권한이 부족합니다",
    Invalid_PermissionGroup: "잘못된 역할 권한입니다",
    Duplicate_Project: "중복된 테스트 프로젝트입니다",
    Duplicate_SportProject: "스포츠 프로젝트 이름이 중복될 수 없습니다",
    Invalid_SportProject: "잘못된 스포츠 프로젝트입니다",
    Invalid_File: "파일이 존재하지 않습니다!",
    UploadFailed_NoFile: "업로드할 파일이 없습니다!",
    DownloadFailed_NoFile: "파일을 찾을 수 없습니다!",
    Incorrect_Format: "데이터 형식이 올바르지 않습니다",
    UploadFailed_Timeout: "업로드 시간 초과!",
    DownloadFailed_Timeout: "다운로드 시간 초과!",
    Repeat_Name: "동명 사용자가 이미 존재합니다",
    Empty_Account: "계정을 입력해 주세요",
    Empty_Password: "비밀번호를 입력해 주세요",
    Empty_Name: "이름을 입력해 주세요",
    Invationing_SubjectEmail: '해당 이메일은 초대 중입니다',
    Invationing_SubjectName: '선수 이름이 초대 중입니다',
    Invalid_InvationLink: '링크가 만료되었습니다',
    Submit_SubjectInfo: '선수가 자료를 제출했습니다',
    Incorrect_Subject: '선수가 존재하지 않습니다',
    Incomplete_InvationCode: '초대 코드가 누락되었습니다',
    Duplicate_Subject: '선수 이름이 이미 존재합니다',
    Duplicate_InvationEmail: '5분 내에 동일한 이메일로 초대할 수 없습니다',
    Invalid_RecordSide: '잘못된 순서입니다',
    NotBe_SameDay: "선택한 날짜는 같은 날이어야 합니다",
    Invalid_Indicator: "잘못된 지표입니다",
    Invalid_UserName: "사용자 닉네임은 비워둘 수 없습니다",
    UnUpload_SubjectOrProject: "테스트 항목 또는 선수가 업로드되지 않았습니다",
    UnUpload_Subject: "선수가 업로드되지 않았습니다",
    Duplicate_SubjectName: "피험자 이름이 중복됩니다",
    SyncData: "먼저 데이터를 가져오세요",
    Duplicate_TrainingPlanName: "중복된 훈련 계획 이름입니다",
    Invalid_TrainingPlan: "잘못된 훈련 계획입니다",
    Invalid_Key: "잘못된 키 값입니다",
    Failed_CallService: "서비스 호출에 실패했습니다",
    FileNotExist: '파일이 존재하지 않습니다',
    Repeat_ProjectName: '프로젝트 이름이 중복됩니다',
}